<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("comments") }}</div>
        <div class="section-subTitle my-2">{{ $t("comments_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Comments')"
          variant="default"
          to="add-schedule-comment"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="searchComments"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing &nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="comments.length > 0"
        v-for="(item, key) in comments"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.comment_name, 1) }}</h6>
            <div>
              <b-dropdown
                right
                variant="edit"
                v-if="$can('update', 'Comments')"
              >
                <b-dropdown-item
                  @click="goToRoute('/master/edit-schedule-comment', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot
                :status="
                  item.comment_is_active === 'Y'
                    ? 'active'
                    : item.comment_is_active === 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="comments.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'comment_name'"
              @click="onSortValue('comment_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('comment_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('comment_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("comment", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="comments.length > 0">
        <tr v-for="(item, key) in comments" :key="key">
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  item.comment_is_active === 'Y'
                    ? 'active'
                    : item.comment_is_active === 'N' && 'inactive'
                "
              />

              <b-dropdown
                right
                variant="edit"
                class="ml-4"
                v-if="$can('update', 'Comments')"
              >
                <b-dropdown-item
                  @click="goToRoute('/master/edit-schedule-comment', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.comment_is_active === 'Y' ? 'active' : 'inactive'"
              />
              <div
                v-if="$can('update', 'Comments')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/master/edit-schedule-comment', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
            </div>
          </td>
          <td>{{ $tc(item.comment_name, 1) }}</td>
        </tr>
      </tbody>
      <tbody v-if="comments.length == 0">
        <tr>
          <td colspan="2">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="comments.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      comments: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
    };
  },
  beforeMount() {
    this.getComments();
    this.getviewingnumber();
  },
  // mounted() {
  //   this.$root.$on("bv::dropdown::show", bvEvent => {
  //     console.log("Dropdown is about to be shown", bvEvent);
  //   });
  // },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getComments();
      } else {
        this.currentPage = event;
        this.getComments();
      }
    },

    goToRoute: function (path, item) {
      console.log("item :", item);
      const { c_id } = item;
      this.$router.push({
        path: path,
        query: {
          c_id: c_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getComments();
    },
    searchComments: function (search) {
      this.getComments(1, search);
    },
    getComments: function (page = undefined, search = undefined) {
      this.comments = [];
      let payload = {
        limit: this.perPage,
        currentPage: page ? page : this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        searchValue: this.searchValue,
      };
      // console.log("body :", body);
      MasterService.GetComments(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.comments = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
              // console.log("Total Rows :", this.rows);
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/commentComponent/comments.vue